import { render, staticRenderFns } from "./ProductListItemVariants.vue?vue&type=template&id=386d8871"
import script from "./ProductListItemVariants.vue?vue&type=script&lang=js"
export * from "./ProductListItemVariants.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports